/* eslint-disable */
import React from 'react';
import './index.less';
import './index.en.less';

export interface IHighlightedCardItem {
  title: string;
  content: string;
  icon?: React.ReactNode;
  active?: boolean;
}

export interface IHighlightedCardsGridProps {
  mainTitle?: string;
  subTitle?: string;
  description?: string;
  items?: IHighlightedCardItem[];
}

const HighlightedCardsGrid: React.FunctionComponent<IHighlightedCardsGridProps> = ({
  mainTitle,
  subTitle,
  description,
  items = [],
}) => {
  return (
    <div className="highlighted-cards-grid">
      {(mainTitle || subTitle || description) && (
        <div className="hcg-header">
          {mainTitle && <h2 className="hcg-main-title">{mainTitle}</h2>}
          {subTitle && <h3 className="hcg-sub-title">{subTitle}</h3>}
          {description && <p className="hcg-description">{description}</p>}
        </div>
      )}
      <div className="hcg-cards-container">
        {items.map((item, index) => (
          <div key={index} className={`hcg-card ${item.active ? 'active' : 'inactive'}`}>
            <div className="hcg-card-header">
              <h4 className="hcg-card-title">{item.title}</h4>
              {item.icon && <div className="hcg-card-icon">{item.icon}</div>}
            </div>
            <div className="hcg-card-content">
              <p className="hcg-card-text">{item.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(HighlightedCardsGrid);
